<div
  class="custom-toast-container"
  [class.success]="toastPackage.toastType === 'toast-success'"
  [class.error]="toastPackage.toastType === 'toast-error'"
  [@flyInOut]="state()"
  (click)="tapToast()"
>
  <div class="toast-content-wrapper">
    <div class="icon-section">
      <lucide-icon [name]="icon" [size]="20" class="toast-icon"></lucide-icon>
    </div>

    <div class="text-section">
      <div class="toast-title" *ngIf="toastTitle">{{ toastTitle }}</div>
      <div class="toast-message" *ngIf="message">{{ message() }}</div>
    </div>

    <div class="close-section" (click)="remove(); $event.stopPropagation()">
      <lucide-icon [name]="X" [size]="18" class="close-icon"></lucide-icon>
    </div>
  </div>
</div>
